import { WithDialog, XlDialogProps } from '@kinderlabs-pos/ui-atoms';
import { Box, Button, DialogActions, DialogContent, Stack, Typography } from '@mui/material';

interface ExitBeaconTagConfirmDialogProps extends XlDialogProps {
	beaconTagCount: number;
	confirmMessage?: string;
	onConfirm: () => void;
}

export const ExitBeaconTagConfirmDialog = ({
	open,
	beaconTagCount,
	confirmMessage,
	onConfirm,
	closeDialog,
}: ExitBeaconTagConfirmDialogProps) => {
	return (
		<WithDialog.XlDialog
			open={open}
			closeDialog={closeDialog}>
			<DialogContent>
				<Stack
					spacing={2}
					alignItems='center'>
					{confirmMessage && <Typography variant='h4'>{confirmMessage}</Typography>}
					<Box
						sx={{
							bgcolor: '#FFF9C4',
							border: '2px solid #F9A825',
							borderRadius: 2,
							px: 4,
							py: 3,
							textAlign: 'center',
						}}>
						<Typography
							variant='h4'
							fontWeight='bold'
							mb={1}>
							{`⚠️ 비콘팔찌 ${beaconTagCount}개를 모두 수거했나요?`}
						</Typography>
						<Typography variant='subtitle1'>퇴장 처리 전에 팔찌를 먼저 수거해주세요.</Typography>
					</Box>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ justifyContent: 'center', pb: 2, gap: 2 }}>
				<Button
					variant='outlined'
					size='large'
					onClick={closeDialog}>
					취소
				</Button>
				<Button
					variant='contained'
					size='large'
					onClick={() => {
						closeDialog?.();
						onConfirm();
					}}>
					확인
				</Button>
			</DialogActions>
		</WithDialog.XlDialog>
	);
};
